import {MultipleChoiceResultModel} from "~~/package/mapper/learning/model/MultipleChoiceResultModel";
import {TaskType} from "~~/package/mapper/learning/model/TaskType";
import {ContestModel} from "~~/package/mapper/contest/model/ContestModel";

export class ContestHelper {
    public static mappingContestTask(contestList: ContestModel[]): ContestModel[] {
        return contestList.map(contest => {
            if ([TaskType.MULTIPLE_CHOICE, TaskType.INSTRUCTION_MULTIPLE_CHOICE].includes(contest.type as TaskType)) {
                const multipleChoiceResult = new MultipleChoiceResultModel();
                multipleChoiceResult.answerList = contest.lastAnswer
                    ? contest.lastAnswer.map(answer => parseInt(answer))
                    : [];
                contest.multipleChoiceQuestion.multipleChoiceResult = multipleChoiceResult;
            } else
                contest.submitCode = contest.lastAnswer
                    ? contest.lastAnswer[0] : "";

            return ContestModel.create({
                ...contest,
                markOrderList: [],
                markQuestionList: [],
                markDictationList: [],
                markSelectionList: []
            });
        });
    }
}
